import { Trans, useLingui } from "@lingui/react/macro";
import { ActivityLogTable } from "@/components/activity/ActivityLogTable";
import { TabHeader } from "./profile-form";

export function ActivityLogTab() {
  const { t } = useLingui();

  return (
    <div className="flex flex-col gap-8">
      <TabHeader
        title={t`Activity Log`}
        description={t`A compact view of your latest actions.`}
      />
      <div className="flex flex-col gap-2">
        <p className="text-sm font-medium text-(--color-text-primary)">
          <Trans>Recent activity</Trans>
        </p>
        <p className="text-sm text-(--color-text-secondary)">
          <Trans>Your latest account and workspace events.</Trans>
        </p>
        <div className="mt-3">
          <ActivityLogTable />
        </div>
      </div>
    </div>
  );
}
